import React, { ReactNode, useLayoutEffect, useState } from "react";
import styles from "./render-only-for-developers.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";

interface RenderOnlyForDevelopersProps {
  children: ReactNode;
}

const cssClassName = "render-only-for-developers";

export const RenderOnlyForDevelopers = ({
  children,
}: RenderOnlyForDevelopersProps) => {
  const authContext = useSelector(
    (state: RootState) => state.yourSlice.authContext,
  );
  const showRenderOnlyForDevelopersStyle = useSelector(
    (state: RootState) => state.yourSlice.showRenderOnlyForDevelopersStyle,
  );

  const permissionName = "view-developer-features";
  const [userIsAllowed, setUserIsAllowed] = useState<boolean>(false);

  useLayoutEffect(() => {
    if (authContext) {
      setUserIsAllowed(authContext.permissions.includes(permissionName));
    }
  }, [authContext]);

  if (userIsAllowed === null) return null;

  return (
    <>
      {userIsAllowed && (
        <>
          {showRenderOnlyForDevelopersStyle ? (
            <div className={styles[cssClassName]}>{children}</div>
          ) : (
            <>{children}</>
          )}
        </>
      )}
    </>
  );
};
